import { render } from "./RestoreAttachBackupVolume.vue?vue&type=template&id=e1139b5c&scoped=true"
import script from "./RestoreAttachBackupVolume.vue?vue&type=script&lang=js"
export * from "./RestoreAttachBackupVolume.vue?vue&type=script&lang=js"

import "./RestoreAttachBackupVolume.vue?vue&type=style&index=0&id=e1139b5c&scoped=true&lang=less"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1139b5c"]])

export default __exports__